import { UseFormSetValue } from 'react-hook-form';
import { calculateSubtotal } from '../utils/calculation.utils';
import { getAutoSetUnits } from '../utils/fieldValidation.utils';

interface UseInputChangeHandlerProps {
  setValue: UseFormSetValue<any>;
  setShowTooltipError?: (value: any) => void;
  tableRowsByFreelancer: { [key: string]: any[] };
  setTableRowsByFreelancer: (value: { [key: string]: any[] }) => void;
  isHourlyPrice: boolean;
  isDailyPrice: boolean;
  isWeeklyPrice: boolean;
  isMonthlyPrice: boolean;
  isAgreementPrice: boolean;
  validateArticleWithPricingTypeAndTooltip: (
    value: string,
    isHourlyPrice: boolean,
    isDailyPrice: boolean,
    isWeeklyPrice: boolean,
    isMonthlyPrice: boolean,
    isAgreementPrice: boolean
  ) => void;
  clearValidationErrors: (errors: any) => void;
  showTooltipError: any;
}

export const useInputChangeHandler = ({
  setValue,
  setShowTooltipError,
  tableRowsByFreelancer,
  setTableRowsByFreelancer,
  isHourlyPrice,
  isDailyPrice,
  isWeeklyPrice,
  isMonthlyPrice,
  isAgreementPrice,
  validateArticleWithPricingTypeAndTooltip,
  clearValidationErrors,
  showTooltipError,
}: UseInputChangeHandlerProps) => {
  
  const handleInputChange = (fieldName: string, value: any) => {
    setValue(fieldName, value);

    // Auto-populate price in service table when hourly price is entered
    if (fieldName === 'hourlyPrice' && value) {
      const priceValue = parseFloat(value);
      if (!isNaN(priceValue) && priceValue > 0) {
        const updatedRowsByFreelancer: { [key: string]: any[] } = {};
        
        Object.keys(tableRowsByFreelancer).forEach(freelancerId => {
          const rows = tableRowsByFreelancer[freelancerId] || [];
          
          updatedRowsByFreelancer[freelancerId] = rows.map((row: any) => {
            const updatedRow = { ...row, price: value };
            const subtotal = calculateSubtotal(row.time, priceValue, row.discount);
            updatedRow.subtotal = subtotal;
            return updatedRow;
          });
        });
        setTableRowsByFreelancer(updatedRowsByFreelancer);
      }
    }

    // Auto-set units based on article and pricing type
    if (fieldName === 'serviceType' && value) {
      const autoUnits = getAutoSetUnits(value, isHourlyPrice);
      if (autoUnits) setValue('workTime', autoUnits);
      validateArticleWithPricingTypeAndTooltip(value, isHourlyPrice, isDailyPrice, isWeeklyPrice, isMonthlyPrice, isAgreementPrice);
    }

    // Clear validation errors
    if (showTooltipError[`null${fieldName}`]) setShowTooltipError?.({ [`null${fieldName}`]: false });
    clearValidationErrors(showTooltipError);
  };

  return { handleInputChange };
};
